import React, { useEffect, useState } from "react";

const Dropdown: React.FC<{
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
  arrowRight?: number;
}> = ({ isOpen, children, className = "", arrowRight = 20 }) => {
  const [isTiny, setIsTiny] = useState(window.innerWidth < 410);

  useEffect(() => {
    const handler = () => setIsTiny(window.innerWidth < 410);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  if (!isOpen) return null;

  if (isTiny) {
    return (
      <div
        className="fixed z-[300]"
        style={{
          top: "calc(60px + 12px)",
          left: "50%",
          transform: "translateX(-50%)",
          width: "calc(100vw - 24px)",
          maxWidth: 360,
        }}
      >
        <div className="bg-white rounded-xl shadow-[0_8px_40px_rgba(0,0,0,0.18)] overflow-hidden">
          {children}
        </div>
      </div>
    );
  }

  // Normal screens — right-aligned
  return (
    <div
      className={`absolute top-[calc(100%+12px)] bg-white rounded-xl shadow-[0_8px_40px_rgba(0,0,0,0.15)] z-[300] ${className}`}
      style={{
        right: 0,
        width: "min(320px, calc(100vw - 24px))",
      }}
    >
      {/* Arrow — only on smaller screens */}
      <div
        className="absolute w-3.5 h-3.5 bg-white rotate-45 shadow-[-2px_-2px_5px_rgba(0,0,0,0.04)]"
        style={{ top: -7, right: Math.max(arrowRight, 12), zIndex: 0 }}
      />
      <div className="relative z-[1] bg-white rounded-xl overflow-hidden">
        {children}
      </div>
    </div>
  );
};

export default Dropdown;
